var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"test_red",attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-1"},[_c('v-col',{staticClass:"content-color px-5 py-2",attrs:{"cols":"12"}},[_c('p',{staticClass:"primary--text text-h6 pa-0 ma-0",domProps:{"textContent":_vm._s(_vm.time)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }